import styled from '@emotion/styled'
import isPropValid from '@emotion/is-prop-valid'
import { css } from '@emotion/react'

import { TextInput } from 'reactGarden/Input'

const rangeStyles =
  ({ theme }) => css`
    appearance: none;
    width: 100%;
    height: 5px;
    margin: 20px 0;
    outline: none;
    border-radius: 5px;
    background: linear-gradient(90deg, ${theme.colors.p400} 50%, ${theme.colors.p600} 100%);
    transition: all 200ms linear;
    overflow-x: visible;

    &::-webkit-slider-thumb {
      appearance: none;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border-color: transparent;
      background: ${theme.colors.p500};
      cursor: grab;
      transition: all 100ms linear;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    }

    &::-moz-range-thumb {
      appearance: none;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border-color: transparent;
      background: ${theme.colors.p500};
      cursor: grab;
      transition: all 100ms linear;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    }

    &::-ms-track {
      width: 100%;
      cursor: pointer;
      background: transparent;
      border-color: transparent;
      color: transparent;
    }

    &:active {
      cursor: grabbing;

      &::-webkit-slider-thumb {
        transform: scale(1.1);
      }
    }
  `

export const Range = styled('input')(rangeStyles)

const titleGroupStyles = () => css`
  display: flex;
  justify-content: space-between;
  margin: 0;
`

export const TitleGroup = styled('ul')(titleGroupStyles)

const titleItemStyles =
  ({ theme }) => css`
    padding: 0 5px;
    font-size: 14px;
    font-weight: ${theme.font.weight.regular};
    display: block;
    width: 22px;
    text-align: center;
  `

export const TitleItem = styled('li')(titleItemStyles)

const weeksGroupStyles = () => css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 77px;
  position: relative;
  padding-bottom: 25px;
`

export const WeeksGroup = styled('div', {
  shouldForwardProp: prop =>
    isPropValid(prop)
})(weeksGroupStyles)

const weeksInputStyles = () => css`
  flex-basis: 18%;
  text-align: center;
  margin-right: 15px;
  cursor: default;
  pointer-events: none;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
`
export const WeeksInput = styled(TextInput, {
  shouldForwardProp: prop =>
    isPropValid(prop)
})(weeksInputStyles)

const weeksLabelStyles = () => css`
  font-size: 16px;
  font-weight: 400;
`

export const WeeksLabel = styled('label')(weeksLabelStyles)

const weeksErrorStyles =
  ({ theme }) => css`
    display: block;
    margin-left: 22px;
    margin-bottom: 8px;
    color: ${theme.colors.r500};
    font-size: 12px;
    position: absolute;
    bottom: 5px;
  `

export const WeeksError = styled('span')(weeksErrorStyles)
